import { BadgeCheck, FileCheck2, Star, Users } from 'lucide-react';

export interface Badges {
  verified: boolean;
  references: number;
  referenceScore?: number | null;
  vigilance: boolean;
}

// Ce que voit un établissement : trois états, jamais de coordonnées ni de commentaires.
export function TrustBadges({ badges }: { badges?: Badges }) {
  if (!badges || (!badges.verified && badges.references === 0 && !badges.vigilance)) return null;
  const pill = { display: 'inline-flex', alignItems: 'center', gap: 4 } as const;
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {badges.verified && (
        <span className="badge badge-available" style={pill} title="SIRET actif et au nom de l'extra, contrôlé dans la base officielle des entreprises">
          <BadgeCheck size={12} /> Vérifié
        </span>
      )}
      {badges.references > 0 && (
        <span className="badge badge-available" style={pill} title="Personnes extérieures ayant confirmé avoir travaillé avec cet extra">
          <Users size={12} /> {badges.references} référence{badges.references > 1 ? 's' : ''} confirmée{badges.references > 1 ? 's' : ''}
        </span>
      )}
      {badges.references > 0 && badges.referenceScore != null && (
        <span className="badge badge-available" style={pill} title="Moyenne pondérée des notes données par les référents sur les compétences du poste">
          <Star size={12} /> Références {badges.referenceScore.toFixed(1)}/5
        </span>
      )}
      {badges.vigilance && (
        <span className="badge badge-available" style={pill} title="Attestation de vigilance URSSAF vérifiée et en cours de validité">
          <FileCheck2 size={12} /> Vigilance URSSAF
        </span>
      )}
    </div>
  );
}
